import { getLocalToken } from "@utils/helpers";

// auth header with token
export const authHeader = (headers) => {
  const token = getLocalToken();
  if (token) {
    headers.set("Authorization", token);
  }

  headers.set("Content-Type", "application/json");
  return headers;
};

// auth header with token and formdata
const authFormdataHeader = (headers) => {
  const token = getLocalToken();

  if (token) {
    headers.set("Authorization", token);
  }
  return headers;
};

//....strategies............
export const headerStrategies = {
  json: authHeader,
  formdata: authFormdataHeader,
};
